import { createContext, useContext, useMemo } from 'react';
import useDerivedDesigns from '@/shared/hooks/useDerivedDesigns';
import * as Groups from '@pkg/entities/groups';
import useTagsStore from '@pkg/entities/tags/useStore';

export const DesignsContext = createContext({
  designs: new Map(),
  isLoading: true,
  supporterMap: new Map(),
  tagMap: new Map(),
});

export const useDesignsContext = () => useContext(DesignsContext);

// Makes a list of hyrdated designs available downstream.
const DesignsProvider = ({ children, designIds }) => {
  const { tags } = useTagsStore();

  const { supporterMap, isLoading: isLoadingSupporters } =
    Groups.useSupporterMap(designIds);

  const { designs, isLoading } = useDerivedDesigns(designIds);

  const context = useMemo(() => {
    return {
      designs,
      isLoading: isLoading || isLoadingSupporters,
      supporterMap,
      tagMap: tags.map,
    };
  }, [designs, isLoading, isLoadingSupporters, supporterMap, tags]);

  return (
    <DesignsContext.Provider value={context}>
      {children}
    </DesignsContext.Provider>
  );
};

export default DesignsProvider;
